import React from "react";
import { withRouter } from 'react-router-dom';
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
import RBCarousel from "react-bootstrap-carousel";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./style.css";
import Button from 'react-bootstrap/Button';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { apiUrl, presentation_Creation_API, myHeaders_Autorized } from 'Api/Api';
import axios from 'axios';
import AudioTimer from './AudioTimer';
import Form from "react-bootstrap/Form";
import { org_friendly_url, user_Status_Ver } from 'Api/Api';
// import sanitize from 'sanitize-filename';
import { local_routes } from 'utils/Routes';
import { supported_languages } from 'utils/supported_languages';

import AudioRecorder from './AudioRecorder/AudioRecorder';

import { isIOS } from "react-device-detect";
//const isIOS = true;

const usingMediaRecorder = typeof window.MediaRecorder !== 'undefined';
//const usingMediaRecorder = false;

class Presentation extends React.PureComponent {
  
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      loading: true,
      message: '',
      fail_message: '',
      ok_to_finish: false, // do we have enough audio to finish/upload?
      audioMimeType: null, // returned from RecorderService so <audio>/<video> tag knows what to display
      force_timerCount: null, // for forcing AudioTimer to a different slide
      current_slide: 1, // for recording per-slide, controlled by dropdown
      presenter_overlay_position: props.presentation_info.presenter_overlay_position || 'bottom_right',
      required_slide_count: props.presentation_info.slide_count || 20,
      seconds_per_slide: props.presentation_info.slide_length || 20,
      max_wrapup_time: 0, // no wrapup time for record per-slide
      slide_indicator: '', // for audio control to display slide number
      showRecordControls: true,
      duration: 0, // recorded audio duration - gotten from AudioTimer
      autoplay: false, // tells RBCarousel whether to play or not
      clickArea: null, // recording state value passed to AudioTimer, retrieved from AudioRecorder callback
      modified_slide_image_urls: [], // passed to RBCarousel to show slides during recording

      final_audioOutput: null, // actual raw recorded/uploaded data - entire presentation
      final_local_file_url: null, // file reference for entire presentation audio control
      audioOutput: null, // actual raw recorded/uploaded data - for one slide
      local_file_url: null, // specifically so audio control can reference - for one slide
      new_recording_flag_array: Array.apply(null, Array(props.presentation_info.slide_count || 20)).map(function () {return null;}), // multi-slide recording, to indicate if we need to upload new audio
      audioOutput_array: Array.apply(null, Array(props.presentation_info.slide_count || 20)).map(function () {return null;}), // multi-slide recording, actual raw recorded/uploaded data
      local_file_url_array: Array.apply(null, Array(props.presentation_info.slide_count || 20)).map(function () {return null;}), // multi-slide recording, specifically so audio control can reference

      //videoOutput_array: Array.apply(null, Array(props.presentation_info.slide_count)).map(function () {return null;}), // multi-slide recording, actual raw recorded/uploaded data
      //video_local_file_url_array: Array.apply(null, Array(props.presentation_info.slide_count)).map(function () {return null;}), // multi-slide recording, specifically so audio control can reference

      audioName: null, // recorded audio filename, received from AudioRecorder
      videoName: null, // recorded video filename, received from VideoRecorder
      
      audioOutputValidate: false, // show "please provide valid audio" message
      audioDelayValidate: false, // show "please use less than 300s for audio delay" message

      //modalLoader: false, // show "audio uploading" message

      delayTime: 0, // introduction time, set in text field
      audioRecordstatus: null, // passed to AudioRecorder, changed by user clicking "record"/"pause"/"finish"
      audioChanged: false, // when uploading, was a new file uploaded?
      audio_delay_changed: false,
      language_selection_changed: false,
      languageSelections: supported_languages,

      languageSelection: "US English (en-US)", // default
      audioFileName: null, // uploaded audio filename, for display purposes

    };

    /*
    this.state = {
      ok_to_finish: false,
      audioMimeType: null,
      force_timerCount: null, // for forcing AudioTimer to a different slide
      current_slide: 1, // for recording per-slide, controlled by dropdown
      required_slide_count: this.props.slide_count,
      seconds_per_slide: this.props.slide_length,
      //max_wrapup_time: this.props.slide_length,
      max_wrapup_time: 0,
      slide_indicator: '', // for audio control to display slide number
      showRecordControls: true,
      duration: 0, // recorded audio duration - gotten from AudioTimer
      autoplay: false, // tells RBCarousel whether to play or not
      clickArea: null, // recording state value passed to AudioTimer, retrieved from AudioRecorder callback
      //audioSrc: null, // Audio Analyzer source
      //audioSrc_reset: false,
      modified_slide_image_urls: [], // passed to RBCarousel to show slides during recording
      //prog: 0,
      final_audioOutput: null, // actual raw recorded/uploaded data - entire presentation
      final_local_file_url: null, // file reference for entire presentation audio control
      audioOutput: null, // actual raw recorded/uploaded data - for one slide
      local_file_url: null, // specifically so audio control can reference - for one slide
      audioOutput_array: Array.apply(null, Array(this.props.slide_count)).map(function () {return null;}), // multi-slide recording, actual raw recorded/uploaded data
      local_file_url_array: Array.apply(null, Array(this.props.slide_count)).map(function () {return null;}), // multi-slide recording, specifically so audio control can reference
      audioName: null, // recorded audio filename, received from AudioRecorder
      audioOutputValidate: false,
      audioDelayValidate: false,
      //showResults: false,
      //showing: false,
      modalLoader: false, // show if audio iis uploading

      delayTime: 0, // introduction time, set in text field
      audioRecordstatus: null, // passed to AudioRecorder, changed by user clicking "record"/"pause"/"finish"
      //audio:0,
      //audioValidate:false,
      audioChanged: false, // when uploading, was a new file uploaded?
      audio_delay_changed: false,
      language_selection_changed: false,
      languageSelections: supported_languages,

      //selectValue: "en-US",
      //defaultLanguage: "US English (en-US)",
      languageSelection: "US English (en-US)", // default
      audioFileName: null, // uploaded audio filename, for display purposes
      //slides_array: Array.apply(null, Array(20)).map(function () {})
    };
    */

    this.workspace_base_url = "";
    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }

    //this.clickArea = props.clickArea || null;
    //console.log("Presentation constructor",this.props.slide_count,this.props.SlideImageArr.length);
    console.log("Presentation constructor",props.presentation_info.language_abbreviation,this.props.presentation_info.slide_count,this.props.slides_array.length);
    //if (props.audio_delay) {
    //  this.state.delayTime = props.audio_delay / 1000;
    //}
    if (props.presentation_info.audio_delay) {
      this.state.delayTime = props.audio_delay / 1000;
    }
    
    if (props.presentation_info.language_abbreviation) {
      for (let language_obj of this.state.languageSelections) {
        if (language_obj.type === props.presentation_info.language_abbreviation) {
          this.state.languageSelection = language_obj['language'];
          break;
        }
      }
    }

    if (props.presentation_info.audio_url) {
      let tmp_array = props.presentation_info.audio_url.split('/');
      this.state.audioFileName = tmp_array[tmp_array.length-1];
    }
    
    if (props.audioType === 'upload') {
      this.state.slide_indicator = 'Cover Slide / Introduction';
    }

    this.audioTimer_handler = this.audioTimer_handler.bind(this);
    
    this.rb_carousel_ref = React.createRef();
    
    /*
    if (props.pkAudio) {
      let tmp_array = props.pkAudio.split('/');
      this.state.audioFileName = tmp_array[tmp_array.length-1];
      //this.state.audioChanged = false; // default to not changed on load
      //this.state.audioOutputValidate = false;
      //this.state.audioValidate = true;
    }
    
    if (props.audioType === 'upload') {
      //this.state.slide_indicator = 'Cover Slide / Introduction';
    }
    */

    //this.audioTimer_handler = this.audioTimer_handler.bind(this);
    
    //this.rb_carousel_ref = React.createRef();
    
    this.recorded_audio_ref = React.createRef(); // to interact with uploaded audio
    
    //this.max_recording_duration = 420; // seconds
    this.max_recording_duration = (this.state.required_slide_count * this.state.seconds_per_slide) + this.state.max_wrapup_time; // seconds

    // for carousel display    
    let modified_slide_image_urls = [];
    if (props.slides_array) {
      let slide_dimensions = '640x360'

      for (let slide_obj of props.slides_array) {

        let image_mod_string = "padblack_"+slide_dimensions;
        let array = slide_obj.image_url.split("/");
        if (props.presentation_info.pad_color) {
          image_mod_string = "pad"+this.props.presentation_info.pad_color+"_"+slide_dimensions;
        }
        modified_slide_image_urls.push(`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/${image_mod_string}/${array[5]}`);
      }
      
      if (props.presentation_info.image_url && props.audioType === 'upload') {
        // add cover image to beginning of slide array
        modified_slide_image_urls.unshift(props.presentation_info.image_url);
      }

      this.state.modified_slide_image_urls = modified_slide_image_urls;
    }
    
    /*
    if (this.props.SlideImageArr) {
      //let slide_dimensions = '1280x360'
      let slide_dimensions = '640x360'
      //if (useMediaQuery('(max-width:600px)')) {
      //  let slide_dimensions = '640x360'
      //}

      for (let slide_obj of this.props.SlideImageArr) {
        //let modified_image_url = slide_obj['source'];

        let image_mod_string = "padblack_"+slide_dimensions;
        let array = slide_obj['source'].split("/");
        if (this.props.pad_color) {
          image_mod_string = "pad"+this.props.pad_color+"_"+slide_dimensions;
        }
        modified_slide_image_urls.push(`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/${image_mod_string}/${array[5]}`);
      }
      
      if (this.props.slide_cover_index && this.props.audioType === 'upload') {
        // add cover image to beginning of slide array
        modified_slide_image_urls.unshift(modified_slide_image_urls[this.props.slide_cover_index]);
      }

      this.state.modified_slide_image_urls = modified_slide_image_urls;
      
    }
    */

    this.auto_play_interval = undefined;
    
    this.previous_seek_pos = 0; // to prevent infinite onSeeking loop
    
    //this._isMounted = false;
    //this.slides_array = Array.apply(null, Array(20)).map(function () {});
    //console.log("slides_array",this.slides_array);
    
    
  }
  
  audioTimer_handler (duration_ms) {
    //console.log("audioTimer_handler",duration);
    this.setState({ duration: (duration_ms / 1000), force_timerCount: null });
    // move slides here
    let tmp_slide_number = Math.floor((duration_ms / 1000) / this.state.seconds_per_slide);
    if (tmp_slide_number >= this.state.required_slide_count) {
      // if they are at the end
      tmp_slide_number = this.state.required_slide_count - 1;
    }
    //console.log("audioTimer_handler",duration,tmp_slide_number,this.state.current_slide);
    //console.log("audioTimer_handler",duration,tmp_slide_number);
    if (this.rb_carousel_ref.current) {
      this.rb_carousel_ref.current.goToSlide(tmp_slide_number);
      if ((duration_ms / 1000) >= this.max_recording_duration) {
        // stop the recording! finish last slide though
        this.controlAudio('finishslide');
        //this.controlAudio('inactive');
      } else if (this.state.clickArea === 'recording' && tmp_slide_number !== 0 && this.state.current_slide !== (tmp_slide_number+1)) {
        if (this.state.local_file_url_array[tmp_slide_number]) {
          // if we already have a recording for the *next* slide, do not do 'nextslide'
          tmp_slide_number = tmp_slide_number-1;
          this.controlAudio('finishslide');
        } else {
          // slide advanced and we don't already have a recording...tell AudioRecorder to switch to another slide
          //this.controlAudio('nextslide');
          tmp_slide_number = tmp_slide_number-1;
          this.controlAudio('finishslide');
        }
      }
      this.setState({current_slide:tmp_slide_number+1});
      // check if over max duration!
    } else {
      // navigated away maybe - do nothing
    }
    
  }
  
  onKeyPress(event) {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
     if (/\+|-/.test(keyValue)) {
       event.preventDefault();
     }
  }

  handleSlideChange = (e) => {
    let new_timerCount = (e.target.value-1) * this.state.seconds_per_slide;
    console.log("handleSlideChange",e.target.value,new_timerCount);
    if (this.state.local_file_url_array[e.target.value-1] && this.state.audioOutput_array[e.target.value-1]) {
      // if we have already recorded this slide, show the audio control
      this.setState({
        current_slide: e.target.value,
        local_file_url: this.state.local_file_url_array[e.target.value-1],
        audioOutput: this.state.audioOutput_array[e.target.value-1],
        force_timerCount: new_timerCount,
        clickArea: 'paused',
        fail_message: null,
        message: null
      });
    } else {
      // no audio recorded for this slide yet
      this.setState({
        current_slide: e.target.value,
        local_file_url: null,
        audioOutput: null,
        force_timerCount: new_timerCount,
        clickArea: 'paused',
        fail_message: null,
        message: null
      });
    }
  }

  handleLanguageChange = (e) => {
    this.setState({ languageSelection: e.target.value, language_selection_changed: true });
  }
  
  handleAudioDelayChange = (e) => {
    console.log("handleAudioDelayChange",this.recorded_audio_ref.current.paused);

    this.setState({
      delayTime: e.target.value,
      audio_delay_changed: true,
      //autoplay:false,
      slide_indicator:'Cover Slide / Introduction'
    });

    this.rb_carousel_ref.current.goToSlide(0);
    this.recorded_audio_ref.current.currentTime = 0;

    
    if (!this.recorded_audio_ref.current.paused) {
      //this.setState({autoplay:true})
      //this.startRecording(e.target.value);
      this.startRecording(e.target.value);
    }
    

  }
  
  /*
  handleChange = (e) => {
    const { languageSelection } = this.state;
    // var input = parseInt(this.value);
    if (e.target.id === "audioDelay") {
      this.setState({ delayTime: e.target.value })
    }
    languageSelection.forEach((item => {
      if (item.language === e.target.value) {
        this.setState({ selectValue: item.type })
      }
    }))
  }
  */

  /*
  autoplay = () => {
    this.setState({ autoplay: this.state.autoplay });
  };
  */

  componentWillUnmount() {
    //this._isMounted = false;
    clearInterval(this.auto_play_interval);
    //AudioTimer = null;
    this.setState({ audioRecordstatus: 'inactive' });
  }

  getRemoteAudioBlob = async (remote_url) => {
    let extension = remote_url.split('.').pop();
    let xhr = new XMLHttpRequest();

    return new Promise( function(resolve, reject) {
      xhr.open('GET', remote_url, true);
      xhr.onerror = function () {
        // this might happen if a previous raw audio upload failed
        console.error("xhr.onerror ERROR getting audio from remote_url",remote_url);
        resolve(null);
      };
      xhr.responseType = "arraybuffer";
      xhr.onload = function () {
        let arrayBufferView = new Uint8Array(this.response);
        let blob = new window.Blob([arrayBufferView], { type: 'audio/'+extension });
        console.log("GOT BLOB",remote_url,blob);
        resolve(blob);
      };
      xhr.send();
    });
  }

  componentDidUpdate() {
    // to handle getting duration to show when done recording
    if (this.recorded_audio_ref && this.recorded_audio_ref.current) {
      console.log("componentDidUpdate with audio ref"); 
      // JBB - this takes some hacking to get the duration
      if (isNaN(this.recorded_audio_ref.current.duration) || this.recorded_audio_ref.current.duration === Infinity) {
        this.recorded_audio_ref.current.onloadedmetadata = (async () => {
          this.recorded_audio_ref.current.currentTime = 1000000;
          this.recorded_audio_ref.current.ontimeupdate = (async () => {
            this.recorded_audio_ref.current.ontimeupdate = null;
            console.log("Retrieved audio duration",this.recorded_audio_ref.current.duration)
            this.recorded_audio_ref.current.currentTime = 0;
          });
        });
      } else if (this.recorded_audio_ref.current.paused) {
        this.recorded_audio_ref.current.currentTime = 0;
      }
    }
  }

  componentDidMount = async function () {
    //this._isMounted = true;

    // Check if we already have per-slide-video
    let tmp_current_slide = 1;
    let tmp_clickArea = null;
    let tmp_local_file_url_array = [...this.state.local_file_url_array];
    let tmp_audioOutput_array = [...this.state.audioOutput_array];
    let xhr_promises = [];
    for (let i = 0; i < this.props.slides_array.length; i++) {
      let slide_obj = this.props.slides_array[i];
      if (slide_obj.audio_url) {
        // get the audio to display locally
        //tmp_local_file_url_array[i] = slide_obj.audio_url;
        xhr_promises.push(this.getRemoteAudioBlob(slide_obj.audio_url));
      } else if (slide_obj.raw_audio_url) {
        xhr_promises.push(this.getRemoteAudioBlob(slide_obj.raw_audio_url));
      } else {
        xhr_promises.push(Promise.resolve(null)); // so the promise array matches the local_file_url array
      }
    }
    tmp_audioOutput_array = await Promise.all(xhr_promises);
    
    // now get "local" URLs for this data
    
    for (let i = 0; i < tmp_audioOutput_array.length; i++) {
      if (tmp_audioOutput_array[i]) {
        tmp_local_file_url_array[i] = window.URL.createObjectURL(tmp_audioOutput_array[i]);
        tmp_current_slide = i+1;
        tmp_clickArea = 'paused';
      }
    }
    
    // figure out if we are ok_to_finish
    let ok_to_finish = true;
    let have_gap = false;
    for (let local_file_url of tmp_local_file_url_array) {
      if (have_gap === false && local_file_url) {
        have_gap = false;
        ok_to_finish = true;
      } else if (have_gap && local_file_url) {
        // gap detected! bailout!
        ok_to_finish = false;
        break;
      } else {
        // missing file...this is ok if there are no gaps...eg we have recordings for slide 1 and 2, but not 3 through 20
        have_gap = true;
      }
    }

    let tmp_fail_message = null;
    if (have_gap && !ok_to_finish) {
      tmp_fail_message = "Audio gap detected - please make sure your audio is continuous before finishing"
    }
    
    
    
    //let audio_blob_array = await Promise.all(xhr_promises);
    
    //tmp_local_file_url_array.forEach((item,i) => {
    //  if (item) {
    //    tmp_audioOutput_array[i] = audio_blob_array.shift();
    //  }
    //});

    console.log("componentDidMount slides",this.props.slides_array);
    console.log("componentDidMount tmp_local_file_url_array", tmp_local_file_url_array);
    console.log("componentDidMount tmp_audioOutput_array", tmp_audioOutput_array);
    //console.log("audio ref?",this.recorded_audio_ref.current);
    if (tmp_local_file_url_array[0]) {
      //this.recorded_audio_ref.current.src = tmp_local_file_url_array[0];
      
      //this.recorded_video_ref.current.srcObject = null;
      //this.recorded_video_ref.current.src = tmp_local_file_url_array[0];
      //this.recorded_video_ref.current.controls = true;
      //this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
    } else {
      //this.recorded_audio_ref.current.src = null;
      
      //this.recorded_video_ref.current.srcObject = null;
      //this.recorded_video_ref.current.src = null;
      //this.recorded_video_ref.current.controls = false;
      //this.prev_recorded_video_ref.current = this.recorded_video_ref.current;
    }
    
    this.setState({
      loading: false,
      current_slide: tmp_current_slide,
      local_file_url: tmp_local_file_url_array[0] || null,
      local_file_url_array: tmp_local_file_url_array,
      audioOutput_array: tmp_audioOutput_array,
      clickArea: tmp_clickArea,
      ok_to_finish,
      fail_message: tmp_fail_message
    })

    /*
    // Edit PK Audio upload
    if (this.props.pkAudio !== undefined && this.props.audioType === 'upload') {
      let audio= this.props.pkAudio;
      var self=this;

      var xhr = new XMLHttpRequest();
      xhr.open("GET", audio, true);
      xhr.responseType = "arraybuffer";
      xhr.onload = function () {
        var arrayBufferView = new Uint8Array(this.response);
        var blob = new window.Blob([arrayBufferView], { type: 'audio/mp3' });
        var urlCreator = window.URL || window.webkitURL;
        let local_file_url = urlCreator.createObjectURL(blob);
        self.setState({
          local_file_url,
          audioDelayValidate: false
        });
          //self.arrBfr( urlCreator.createObjectURL(blob) )
      };
      xhr.send();
    }
    */
  }
  
  /*
  arrBfr=(data)=>{
    this.setState({
      local_file_url: data,
      audioOutputValidate: false 
    })
  }
  */

  TriggerCreateVideo = async () => {
    console.log("TriggerCreateVideo");


    // make sure we have audio...tricky because if there is already audio (edit) and it didn't change, we won't have audioOutput
    if (!this.state.local_file_url_array[0]) {
      this.setState({
        //audioOutputValidate: true,
        //modalLoader: false
        message: null,
        fail_message: 'Missing at least the first slide audio - please record at least one slide before continuing'
      });
      return;
    } else if (!this.state.ok_to_finish) {
      this.setState({
        message: null,
        fail_message: 'Audio gap detected - please make sure your audio is continuous before finishing'
      });
      return;
    } else {
      this.setState({
        message: 'Working...',
        saving: true,
        fail_message: null
      });
    }
    
    // upload new slide video
    await this.AudioPushMet(true);

    // if user is not verified, they can't publish/create videos and transcriptions
    if (user_Status_Ver !== "1") {
      console.log("User is not verified - cannot publish (create video/transcript)");
      this.props.next();
      return;
    }
    
    // do we need to create new video?
    console.log("Trigger Decision",this.state.audioChanged,this.state.language_selection_changed,this.state.audio_delay_changed,this.props.audioType);
    let make_video_bool = false;
    let make_transcript_bool = false;
    if (this.props.slidesChanged) {
      make_video_bool = true;
    }
    
    if (this.state.audioChanged || !this.props.presentation_info.auto_generated_transcript) {
      make_video_bool = true;
      make_transcript_bool = true;
    }
    if (this.state.language_selection_changed) {
      make_transcript_bool = true;
    }
    if (this.state.audio_delay_changed) {
      make_video_bool = true;
    }

    let PatchImageInPresentation = {
        "audio_delay": 0,
        "wrapup_time_ms": 0,
        //"video_assembly_method": "presentation_audio",
        "video_assembly_method": "slide_audio",
        "trigger_create_presentation_video": make_video_bool,
        //"trigger_create_presentation_pptx": make_video_bool,
        audio_url: ""
        //"trigger_create_presentation_transcript": make_transcript_bool,
    }      

    //console.log("Final presentation patch for trigger and audio options",JSON.stringify(PatchImageInPresentation,null,2));
    console.log("Final presentation patch for trigger and audio options");

    await axios.patch(`${presentation_Creation_API}/${this.props.presentation_info.entity_uuid}`, PatchImageInPresentation, myHeaders_Autorized);
    
    // sleep for 2s so My PKs displays processing properly
    if (make_video_bool || make_transcript_bool) {
      this.setState({
        message: 'Starting Presentation Video Creation Process'
      })

      setTimeout(() => {
        this.props.next();
      }, 1000);
    } else {
      this.props.next();
    }
    return;
  }

  saveProgress = async () => {
    this.setState({
      message: 'Working...',
      saving: true,
      fail_message: null
    })
    await this.AudioPushMet(false);
    this.setState({
      saving: false,
      message: 'All changes saved'
    })
  }

  // API Calls for uploading recorded/uploaded audio, and then triggering video/transcribe creation
  AudioPushMet = async (final_upload = false) => {
    console.log("AudioPushMet");
    
    // get language abbreviation value for database
    let language_abbreviation = "en-US"; // default if something went horribly wrong
    for (let language_obj of this.state.languageSelections) {
      if (language_obj['language'] === this.state.languageSelection) {
        language_abbreviation = language_obj.type;
      }
    }

    let presentationEntityId = this.props.presentation_info.entity_uuid;

    if (presentationEntityId === null) {
      console.error("ERROR - no presentation uuid");
      return;
    }

    /*
    this.setState({
      message: 'Working...',
      saving: true,
      fail_message: null
    });
    */
    
    if (this.state.audioChanged) {
      console.log("Uploading audio per slide",this.state.audioOutput_array);
      //let tmp_audioOutput_array = [...this.state.audioOutput_array];
      let tmp_new_recording_flag_array = [...this.state.new_recording_flag_array];

      for (let i = 0; i < this.state.audioOutput_array.length; i++) {
        if (!this.state.new_recording_flag_array[i]) {
          // already uploaded this, or there is no audio
          console.log("Already uploaded audio for slide ",i);
          continue;
        }
        let tmp_audioOutput = this.state.audioOutput_array[i];
        let slide_obj = this.props.slides_array[i];

        let audioPromise;
        let audioPromise_response;
        //let self = this;
        if (tmp_audioOutput) {
          audioPromise = new Promise(resolve => {
            let reader = new FileReader();
            reader.readAsArrayBuffer(tmp_audioOutput);
            reader.onload = () => resolve(reader.result);
          });
          audioPromise_response = await audioPromise;
        } else {
          // this is ok (for now) if we don't have data for every slide
          continue;
        }
        
        if (!audioPromise_response) {
          console.error("Audio File Data Read Failed!");
          return;
        }

        let extension = "webm";
        if (this.state.audioMimeType.startsWith('audio/wav')) {
          extension = "wav";
        } else if (this.state.audioMimeType.startsWith('audio/mp4')) {
          extension = "mp4";
        }

        /*
        let extension = 'webm';
        if (this.state.audioMimeType.startsWith(('audio/wav'))) {
          extension = 'wav';
        }
        */
        
        let tmp_audio_filename = 'slide_'+(i+1)+'_'+(new Date().getTime())+'.'+extension;

        let response = await axios.post(`${apiUrl}slides/${slide_obj.entity_uuid}/getUploadSignedUrl?asset_type=raw_audio&filename=${tmp_audio_filename}`, myHeaders_Autorized);
        if (response === null) {
          console.error("ERROR - slide audio getUploadSignedUrl FAILED");
          return;
        }

        let dataRes = response.data;
        let audio_length_bytes = audioPromise_response.byteLength;
        const config = {
          headers: { "Content-Type": dataRes.content_type },
          onUploadProgress: (progressEvent) => {
            let upload_percent = Math.floor(progressEvent.loaded / audio_length_bytes * 100);
            //console.log("AUDIO UPLOADING PROGRESS",progressEvent.loaded,upload_percent);
            this.setState({
              message: 'Slide '+(i+1)+' Audio: Uploaded '+upload_percent+'%'
            });
          }
        };
        
        // audio upload
        await axios.put(dataRes.upload_url, audioPromise_response, config);
        tmp_new_recording_flag_array[i] = null; // so we know we already uploaded this
        
        // now we want to trigger process raw audio to mp3 audio for the slide
        let patch_obj = {
          trigger_create_slide_mp3_audio: true,
          audio_url: ""
        }
        await axios.patch(`${apiUrl}slides/${slide_obj.entity_uuid}`, patch_obj, myHeaders_Autorized);
      }
      
      this.setState({
        new_recording_flag_array: tmp_new_recording_flag_array
        //audioOutput_array: tmp_audioOutput_array
      });
    }
    
    let patch_obj = {
      language_abbreviation: language_abbreviation,
    }      

    //console.log("Final presentation patch for trigger and audio options",JSON.stringify(PatchImageInPresentation,null,2));
    console.log("Saving language");

    await Promise.all([
      axios.patch(`${presentation_Creation_API}/${presentationEntityId}`, patch_obj, myHeaders_Autorized)
    ]);

    /*
    this.setState({
      message: 'All changes saved'
    })
    */
    
    return;
  }

  recordNextSlide = () => {
    console.log("recordNextSlide",this.state.current_slide);
    let new_timerCount = this.state.current_slide * this.state.seconds_per_slide;
    this.controlAudio('recording', this.state.current_slide+1);
    this.setState({ force_timerCount: new_timerCount });
    //this.setState({ current_slide: this.state.current_slide+1 });
  }

  resetPresentationRecording = () => {
    console.log("resetPresentationRecording");
    
    this.setState({
      local_file_url: this.state.local_file_url_array[0],
      audioOutput: this.state.audioOutput_array[0],
      force_timerCount: 0,
      fail_message: null,
      message: null,
      final_audioOutput: null,
      final_local_file_url: null,
      audioRecordstatus: 'paused',
      clickArea: 'paused',
      current_slide: 1,
      autoplay: false
    });
    this.rb_carousel_ref.current.goToSlide(0);
    
    /*
    let new_state = {
      audioChanged: false,
      ok_to_finish: false,
      audioMimeType: null,
      force_timerCount: null, // for forcing AudioTimer to a different slide
      current_slide: 1, // for recording per-slide, controlled by dropdown
      slide_indicator: '', // for audio control to display slide number
      showRecordControls: true,
      duration: 0, // recorded audio duration - gotten from AudioTimer
      autoplay: false, // tells RBCarousel whether to play or not
      clickArea: null, // recording state value passed to AudioTimer, retrieved from AudioRecorder callback
      //modified_slide_image_urls: [], // passed to RBCarousel to show slides during recording

      final_audioOutput: null, // actual raw recorded/uploaded data - entire presentation
      final_local_file_url: null, // file reference for entire presentation audio control
      audioOutput: null, // actual raw recorded/uploaded data - for one slide
      local_file_url: null, // specifically so audio control can reference - for one slide
      audioOutput_array: Array.apply(null, Array(this.props.slide_count)).map(function () {return null;}), // multi-slide recording, actual raw recorded/uploaded data
      local_file_url_array: Array.apply(null, Array(this.props.slide_count)).map(function () {return null;}), // multi-slide recording, specifically so audio control can reference
      audioName: null, // recorded audio filename, received from AudioRecorder
      audioOutputValidate: false,
      audioDelayValidate: false,
      modalLoader: false, // show if audio is uploading

      delayTime: 0, // introduction time, set in text field
      audioRecordstatus: null, // passed to AudioRecorder, changed by user clicking "record"/"pause"/"finish"
      audioChanged: false, // when uploading, was a new file uploaded?
      audio_delay_changed: false,
      language_selection_changed: false,
      languageSelections: supported_languages,

      //languageSelection: "US English (en-US)", // default
      audioFileName: null, // uploaded audio filename, for display purposes
    };
    this.setState(new_state);
    */
  }

  // Audio recording 
  controlAudio(audioRecordstatus, current_slide = this.state.current_slide) {
    console.log("controlAudio",current_slide,this.state.audioRecordstatus,audioRecordstatus);
    let new_state = {...this.state};
    if (audioRecordstatus === 'recording') {
      new_state.local_file_url = null;
      let tmp_local_file_url_array = this.state.local_file_url_array;
      tmp_local_file_url_array[current_slide-1] = null;
      new_state.local_file_url_array = tmp_local_file_url_array;
      if (this.state.audioRecordstatus === 'inactive') {
        // starting/restarting from scratch
        this.rb_carousel_ref.current.goToSlide(0);
        new_state.duration = 0;
        //new_state.duration = 0;
      }
      //new_state.audioOutput = null;
      //new_state.slide_indicator = '';
    } else if (audioRecordstatus === 'inactive') {
      // this is a "finish whole thing"
      //new_state.local_file_url = null;
      new_state.clickArea = 'inactive';
      this.rb_carousel_ref.current.goToSlide(0);
      new_state.duration = 0;
      new_state.local_file_url = null;
      
      //new_state.local_file_url_array = Array.apply(null, Array(this.props.presentation_info.slide_count)).map(function () {return null;});
      //new_state.clickArea = 
    }
    //if (audioRecordstatus !== 'nextslide') {
    //  new_state.showRecordControls = false;
    //}
    new_state.showRecordControls = false;
    new_state.audioRecordstatus = audioRecordstatus;
    new_state.audioOutputValidate = false;
    new_state.current_slide = current_slide;
    new_state.fail_message = null;
    new_state.message = null;
    
    console.log(" local_file_url_array",new_state.local_file_url_array);
    
    this.setState(new_state);
    /*
    this.setState({
      showRecordControls: false,
      audioRecordstatus,
      audioOutputValidate: false,
      //clickArea: 'shownothing'
    });
    */

    //this.clickArea = audioRecordstatus;
  }

  /*
  onAutoPlaySlideChange = (slide_number) => {
    console.log("onAutoPlaySlideChange",slide_number);
  }
  */

  // audio upload autoplay start method
  seekRecording = () => {
    //console.log("seekRecording 1",this.recorded_audio_ref.current.currentTime,this.previous_seek_pos,this.state.delayTime);
    if (Math.abs(this.recorded_audio_ref.current.currentTime - this.previous_seek_pos) < 1) {
      //console.log("seekRecording bailout");
      return;
    } else {
      
    }
    clearInterval(this.auto_play_interval);
    
    let tmp_delay_time = this.state.delayTime;
    if (!tmp_delay_time) {
      tmp_delay_time = 0;
    }
    tmp_delay_time = parseInt(tmp_delay_time);
    
    let adjusted_time = this.recorded_audio_ref.current.currentTime;
    let start_at_zero = false;
    if (this.state.delayTime) {
      adjusted_time = adjusted_time - tmp_delay_time;
      if (adjusted_time < 0) {
        adjusted_time = 0;
        start_at_zero = true;
      }
    }
    let tmp_slide_number = Math.floor(adjusted_time / this.state.seconds_per_slide);
    
    // can't go over slide 20; meaning index 19 here
    if (tmp_slide_number >= this.state.required_slide_count) {
      tmp_slide_number = this.state.required_slide_count - 1;
    }
    
    //console.log("HMM",start_at_zero,tmp_slide_number,tmp_delay_time);
    if (this.rb_carousel_ref.current) {
      // seek to nearest slide break!
      if (start_at_zero && this.props.audioType === 'upload') {
        this.recorded_audio_ref.current.currentTime = 0;
        this.setState({slide_indicator:'Cover Slide / Introduction'});
        this.rb_carousel_ref.current.goToSlide(0);
        //if (!this.recorded_audio_ref.current.paused) {
        //  this.startRecording();  
        //}
      } else {
        
        this.recorded_audio_ref.current.currentTime = (tmp_slide_number * this.state.seconds_per_slide) + tmp_delay_time;
        this.setState({slide_indicator:'Slide '+(tmp_slide_number+1)});
        if (this.props.audioType === 'upload') {
          console.log("Going to slide "+(tmp_slide_number+1));
          this.rb_carousel_ref.current.goToSlide(tmp_slide_number+1);
        } else {
          this.rb_carousel_ref.current.goToSlide(tmp_slide_number);
        }
      }
      this.previous_seek_pos = this.recorded_audio_ref.current.currentTime;
      //this.recorded_audio_ref.current.pause();
      
      //console.log("seekRecording 2",this.recorded_audio_ref.current.currentTime,this.state.delayTime,adjusted_time,tmp_slide_number);
    } else {
      // navigated away maybe - do nothing
    }
  }

  onAutoPlaySlideChange = (slide_number) => {
    if (!this.recorded_audio_ref.current) {
      // do nothing - we are recording
      return;
    }
    console.log("onAutoPlaySlideChange",slide_number,this.recorded_audio_ref.current.paused);
    if (!this.recorded_audio_ref.current.paused) {
      if (this.props.audioType === 'upload') {
        // handle cover slide
        if (slide_number === 0) {
          this.setState({slide_indicator: 'Cover Slide / Introduction'});
        } else {
          this.setState({slide_indicator: 'Slide '+slide_number});
        }
        
      } else if (this.state.audioRecordstatus === 'inactive') {
        // no cover slide
        this.setState({slide_indicator: 'Slide '+(slide_number+1)});
      }
    }
  }

  // audio upload autoplay start method
  startRecording = (inc_delay_time) => {
    let tmp_delay_time;
    if (inc_delay_time && !isNaN(parseInt(inc_delay_time))) {
      tmp_delay_time = parseInt(inc_delay_time);
    } else {
      if (this.state.delayTime) {
        tmp_delay_time = parseInt(this.state.delayTime);
      } else {
        tmp_delay_time = 0;
      }
    }
    console.log("startRecording",tmp_delay_time,this.recorded_audio_ref.current.currentTime);
    clearInterval(this.auto_play_interval);
    // don't start slideshow until we get past intro
    if (tmp_delay_time && (this.recorded_audio_ref.current.currentTime < tmp_delay_time)) {
      let interval_ms = (tmp_delay_time - this.recorded_audio_ref.current.currentTime) * 1000;
      console.log("Intro - delaying autoplay",interval_ms);
      this.auto_play_interval = setInterval(() => {
        clearInterval(this.auto_play_interval);
        
        this.setState({
          autoplay: true,
        });
        this.setState({slide_indicator:'Slide 1'});
        this.rb_carousel_ref.current.goToSlide(1);
      }, interval_ms);
    } else if (this.recorded_audio_ref.current.currentTime < 0.01) {
      this.setState({slide_indicator:'Slide 1'});
      if (this.props.audioType === 'upload') {
        this.rb_carousel_ref.current.goToSlide(1);
      } else {
        this.rb_carousel_ref.current.goToSlide(0);
      }
      console.log("Autoplay started at Slide 1 with no audioDelay");
      this.setState({
        autoplay: true,
      })
    } else {
      console.log("Autoplay started");
      this.setState({
        autoplay: true,
      })
    }
  }
  
  // audio upload autoplay pause method
  pauseRecording = () => {
    // jump to beginning of the current slide
    this.seekRecording();
    clearInterval(this.auto_play_interval);
    this.setState({
      autoplay: false,
    })
  }
  
  // Audio file upload method
  onChangeAudioFile(event) {
    if (event.target.files[0] !== null && event.target.files[0] !== undefined) {
      let local_file_url = window.URL.createObjectURL(event.target.files[0]);
      this.rb_carousel_ref.current.goToSlide(0);
      this.setState({
        audioOutput: event.target.files[0],
        audioName: event.target.files[0].name,
        audioFileName: event.target.files[0].name,
        local_file_url: local_file_url,
        audioChanged: true,
        audioOutputValidate:false,
        autoplay:false,
        slide_indicator:'Cover Slide / Introduction'
      })
    }
    /*
    let local_file_url = window.URL.createObjectURL(event.target.files[0]);
    if (local_file_url !== this.state.audioOutput) {
      // different file!
      this.setState({
        file: local_file_url,
        audioChanged: true,
        audioOutputValidate:false
      })
    }
    */
  }

  onClickPre = () => {
    this.props.prev()
  }

  handleCancel = async () => {
    //let next_page = `${this.workspace_base_url}${local_routes.pklist}`;
    //this.props.history.push(next_page);
    
    let next_page = `${this.workspace_base_url}${local_routes.pklist}`;
    if (this.props.source_info && this.props.source_info.referrer) {
        next_page = this.props.source_info.referrer;
    }
    this.props.history.push(next_page);
  }

  render() {
    //const { audioSrc, audioRecordstatus, showRecordControls, modalLoader, audioOutputValidate, audioDelayValidate, languageSelections } = this.state;
    const { audioRecordstatus, showRecordControls, audioOutputValidate, audioDelayValidate, languageSelections } = this.state;
    
    let carousel_holder_class = 'carousel-holder-black';
    if (this.props.presentation_info.pad_color && this.props.presentation_info.pad_color === 'white') {
      carousel_holder_class = 'carousel-holder-white';
    }
    
    //let modified_slide_image_urls = this.get_modified_slide_image_urls();
    // Recording Audio start, pause & stop functions
    /*
    const audioProps = {
      audioType: "audio/mp3", // Temporarily only supported audio/wav, default audio/webm
      status: audioRecordstatus, // Triggering component updates by changing status
      timeslice: 1000,
      audioSrc,
      audioOutput,
      startCallback: () => {
        this.setState({
          autoplay: true,
          clickArea: 'recording'
        })
      },
      pauseCallback: () => {
        this.setState({
          autoplay: false,
          clickArea: 'paused'
        })
      },
      stopCallback: (e) => {
        console.log("stopCallback");
        let local_file_url = window.URL.createObjectURL(e);
        this.setState({
          audioSrc: local_file_url,
          local_file_url: local_file_url,
          autoplay: false,
          clickArea: 'inactive',
          audioOutput: (e),
          audioName: `${this.props.PKCreationPresentationName}.mp3`
        })
      }
    }
    */
    const audioProps = {
      //audioType: "audio/mp3", // Temporarily only supported audio/wav, default audio/webm
      //status: audioRecordstatus, // Triggering component updates by changing status
      //timeslice: 1000,
      //audioSrc,
      //audioOutput,
      //audioSrc_reset,
      recording_status: audioRecordstatus,
      //current_slide: this.state.current_slide,
      audioOutput_array: this.state.audioOutput_array,
      
      // after we start recording a slide
      startCallback: () => {
        console.log("startCallback");
        this.setState({
          //autoplay: true,
          local_file_url: null,
          clickArea: 'recording',
          showRecordControls: true
        })
      },
      
      // pause/unpause are not used when recording per slide
      pauseCallback: () => {
        console.log("pauseCallback");
        //let snapped_duration = this.state.duration - (this.state.duration % this.state.seconds_per_slide);
        this.setState({
          //autoplay: false,
          clickArea: 'paused',
          showRecordControls: true,
          //duration: snapped_duration
        })
      },
      unpauseCallback: () => {
        console.log("unpauseCallback");
        this.setState({
          //autoplay: false,
          clickArea: 'recording',
          showRecordControls: true
        })
      },
      
      // returned after a "finish" command is sent, should have the final concatenated audio
      stopCallback: (audioOutput,local_file_url,audioMimeType) => {
        console.log("stopCallback",local_file_url);
          this.setState({
            audioMimeType,
            final_local_file_url: local_file_url,
            final_audioOutput: audioOutput,
            local_file_url: null,
            //local_file_url_array: tmp_local_file_url_array,
            //audioOutput_array: tmp_audioOutput_array,
            clickArea: 'inactive',
            audioName: `${this.props.PKCreationPresentationName}.mp3`,
            showRecordControls: true
          })
      },
      
      // got the actual per-slide audio back
      finishCallback: (audioOutput,local_file_url,audioMimeType) => {
        console.log("finishCallback",local_file_url);
        //console.log(" local_file_url_array",this.state.local_file_url_array);
        let audio_data_index = this.state.current_slide-2;
        let tmp_local_file_url = null;
        if (this.state.clickArea === 'paused') {
          // if this is a finish from finishSlide, vs from nextslide
          audio_data_index = this.state.current_slide-1;
          tmp_local_file_url = local_file_url;
        }
        console.log(" local_file_url_array",this.state.local_file_url_array);
        let tmp_local_file_url_array = [...this.state.local_file_url_array];
        tmp_local_file_url_array[audio_data_index] = local_file_url;
        let tmp_audioOutput_array = [...this.state.audioOutput_array];
        tmp_audioOutput_array[audio_data_index] = audioOutput;
        let tmp_new_recording_flag_array = [...this.state.new_recording_flag_array];
        tmp_new_recording_flag_array[audio_data_index] = true;
        console.log(" tmp_local_file_url_array",tmp_local_file_url_array);
        console.log(" tmp_audioOutput_array",tmp_audioOutput_array);
        console.log(" tmp_new_recording_flag_array",tmp_new_recording_flag_array);


        
        // figure out if we are ok_to_finish
        let have_gap = false;
        let ok_to_finish = true;
        for (let local_file_url of tmp_local_file_url_array) {
          if (have_gap === false && local_file_url) {
            have_gap = false;
            ok_to_finish = true;
          } else if (have_gap && local_file_url) {
            // gap detected! bailout!
            ok_to_finish = false;
            break;
          } else {
            // missing file...this is ok if there are no gaps...eg we have recordings for slide 1 and 2, but not 3 through 20
            have_gap = true;
          }
        }

        let tmp_fail_message = null;
        if (have_gap && !ok_to_finish) {
          tmp_fail_message = "Audio gap detected - please make sure your audio is continuous before finishing"
        }

        this.setState({
          audioChanged: true,
          audioMimeType,
          local_file_url: tmp_local_file_url,
          local_file_url_array: tmp_local_file_url_array,
          audioOutput_array: tmp_audioOutput_array,
          new_recording_flag_array: tmp_new_recording_flag_array,
          showRecordControls: true,
          ok_to_finish,
          fail_message: tmp_fail_message
        });

        // is this the last slide?
        if (ok_to_finish && audio_data_index === tmp_local_file_url_array.length-1) {
          // we have them all - set to inactive to make AudioRecorder concat the audio files
          //this.controlAudio("inactive");
          //return;
        }
        
      },
      // JBB - nextSlideCallback is NOT being used atm
      nextSlideCallback: () => {
        console.log("nextSlideCallback");
        //console.log(" local_file_url_array",this.state.local_file_url_array);
        this.setState({
          //showRecordControls: true,
          //audioRecordstatus: 'recording'
          audioRecordstatus: 'inactive'
        });
      },
      
      // returned after a slide is done recording, but before actual audio is processed
      finishSlideCallback: () => {
        console.log("finishSlideCallback");
        this.setState({
          clickArea: 'paused',
          showRecordControls: false,
          audioRecordstatus: 'paused',
          force_timerCount: ((this.state.current_slide-1) * this.state.seconds_per_slide)
        });
      },
      
      failureCallback: () => {
        this.props.backToSelectAudio();
      }
    };
    
    let upload_button_text = "Upload Audio File";
    if (this.state.audioFileName) {
      upload_button_text = "Upload New Audio File";
    }

    //console.log("RENDER",this.state.current_slide);

    if (this.state.loading === true) {
        return (
            <ActivityIndicator theme="spinner" />
        )
    }


    return (
      <div className="container-fluid form-card" id="slides-carousel">
        {
          this.state.message &&
            <p className="PKAudioSuccess flex-center">{this.state.message}</p>
        }
        {
          this.state.fail_message &&
            <p className="PKAudioError flex-center">{this.state.fail_message}</p>
        }
        
        {/* Validations */}
        {
          audioDelayValidate === true
            ?
            <p className="PKAudioError flex-center">Audio delay should not have more that 300 seconds</p>
            :
            null
        }

        {
          audioOutputValidate === true
            ?
            <p className="PKAudioError flex-center">Please provide valid audio</p>
            :
            null
        }
        {/*
        {modalLoader === true ?
            <p className="PKAudioSuccess flex-center">Audio Uploading</p>
            :
            null
        }
        */}
        <Row>
          <Col xs={6} style={{ fontSize:"smaller", cursor: "pointer" }} onClick={() => this.props.backToSelectAudio()}>
            <i className="fa fa-angle-double-left"></i> Go Back to Select Audio
          </Col>
          <Col xs={6} className="flex justify-content-end">
            { this.state.audioChanged &&
              <Button
                variant="pkprimary"
                onClick={this.saveProgress}
                disabled={!this.state.showRecordControls || this.state.clickArea === 'recording' || this.state.saving}
              >
                Save Progress
              </Button>
            }
          </Col>
        </Row>
        
        <Row>
          <Col span={12} style={{ padding:"0px", paddingTop: "20px" }} className="">
            <RBCarousel
              defaultActiveIndex={this.state.current_slide-1}
              className={carousel_holder_class}
              animation={false}
              leftIcon={false}
              wrap={false}
              autoplay={this.state.autoplay} // used for uploaded audio
              //autoplay={false}
              slideshowSpeed={this.state.seconds_per_slide * 1000}
              controls={false}
              onSelect={this.onAutoPlaySlideChange}
              version={4}
              ref={this.rb_carousel_ref}
              pauseOnVisibility={false}
            >
              {this.state.modified_slide_image_urls.map((item) =>
                  <div key={item} className="carousel-img">
                    <img style={{ border:"1px solid black", width: "100%", height: "100%" }} src={item} alt="img"/>
                    {/* <img src={item} alt="img"/> */}
                  </div>
                )
              }
            </RBCarousel>
          </Col>
        </Row>
        <div>
          <Form>
            {/* Language Selection dropdown */}
            <Form.Group controlId="lanTranscript">
              <div className="form-dropdownlist lang-dropdownlist">
                <Form.Control
                  as="select"
                  required
                  onChange={this.handleLanguageChange}
                  value={this.state.languageSelection}
                  //defaultValue={this.state.defaultLanguage}
                >
                  {
                    languageSelections.map((item) =>
                      <option key={item.type}>{item['language']}</option>
                    )
                  }
                </Form.Control>
              </div>
            </Form.Group>

            {/* Audio delay in upload option */}
            { this.props.audioType === "upload" &&
            <Form.Group controlId="audioDelay">
                  <div className="form-dropdownlist">
                    <Form.Label>Intro Length (seconds until first slide)</Form.Label>
                    <Form.Control
                      required
                      type="number"
                      min="0"
                      max="300"
                      placeholder="In seconds - 300 maximum"
                      onChange={this.handleAudioDelayChange}
                      onKeyPress={this.onKeyPress.bind(this)}
                      value={this.state.delayTime}
                    />
                  </div>
            </Form.Group>
            }
            { this.props.audioType === "record_per_slide" && this.state.clickArea !== 'inactive' &&
            <Form.Group controlId="current_slide">
              <div className="form-dropdownlist lang-dropdownlist">
                <Form.Control
                  as="select"
                  required
                  disabled={!this.state.showRecordControls || this.state.clickArea === 'recording' || this.state.final_local_file_url}
                  onChange={this.handleSlideChange}
                  value={this.state.current_slide}
                  //defaultValue={this.state.defaultLanguage}
                >
                  {
                    this.state.local_file_url_array.map((local_file_url,index) => {
                      let slide_number = index+1;
                      return <option value={slide_number} key={slide_number}>Slide {slide_number}{local_file_url ? ' RECORDED' : ''}{local_file_url && !this.state.new_recording_flag_array[index] ? ' SAVED' : ''}</option>;
                      //if (local_file_url) {
                      //  return <option value={slide_number} key={slide_number}>Slide {slide_number}{local_file_url ? ' RECORDED' : ''}</option>;
                      //} else if (this.state.current_slide-1 === index) {
                      //  return <option value={slide_number} key={slide_number}>Slide {slide_number}</option>;
                      //}
                      /*
                      if (local_file_url) {
                        return <option value={slide_number} key={slide_number}>Slide {slide_number} RECORDED</option>;
                      } else {
                        return <option value={slide_number} key={slide_number}>Slide {slide_number}</option>;
                      }
                      */
                    })
                  }
                </Form.Control>
              </div>
            </Form.Group>
            }
            
          </Form>
        </div>
        {
          this.props.audioType === "record_per_slide" ?
            // Recording Audio section
            // JBB 2/6/2020 - break this down per slide
            <Row>
              <Col lg={12}>
                <AudioTimer
                  audioTimer_handler={this.audioTimer_handler}
                  clickArea={this.state.clickArea}
                  force_timerCount={this.state.force_timerCount}
                  seconds_per_slide={this.state.seconds_per_slide}
                  required_slide_count={this.state.required_slide_count}
                />
                
                <div className="audio-recording">
                  
                  <div className="recording btnControls">

                    {/*<AudioAnalyser {...audioProps}>*/}
                      <div className="btn-box recording-button">
                        {showRecordControls ?
                          <div>
                            {this.state.clickArea === null &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                //secondary={true}
                                onClick={() => this.controlAudio("recording")}>Start Slide {this.state.current_slide} Recording</Button>}
                            {this.state.clickArea === "inactive" && this.state.local_file_url !== null &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                //secondary={true}
                                onClick={() => this.controlAudio("recording")}>Restart Slide {this.state.current_slide} Recording</Button>}
                            {this.state.clickArea === "inactive" && this.state.final_local_file_url !== null &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                //secondary={true}
                                onClick={() => this.resetPresentationRecording()}>Go Back to Slide Audio</Button>}
                            {/*
                            {this.state.clickArea === "recording" &&
                              <Button className="btn-success"
                                variant="secondary"
                                //secondary={true}
                                onClick={() => this.controlAudio("paused")}>Pause Recording</Button>}
                            */}
                            {this.state.clickArea === "paused" && this.state.local_file_url !== null &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                //secondary={true}
                                onClick={() => this.controlAudio("recording")}>Restart Slide {this.state.current_slide} Recording</Button>}
                            {this.state.clickArea === "paused" && this.state.local_file_url === null &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                //secondary={true}
                                onClick={() => this.controlAudio("recording")}>Start Slide {this.state.current_slide} Recording</Button>}

                            {(this.state.clickArea === "paused" && this.state.local_file_url !== null && this.state.current_slide < this.state.required_slide_count) &&
                              <Button className="btn-success"
                                variant="secondary"
                                disabled={this.state.saving}
                                //secondary={true}
                                onClick={() => this.recordNextSlide()}>Start Recording Next Slide ({this.state.current_slide+1}) </Button>}
                            {/*
                            {(this.state.clickArea === "paused") && this.state.ok_to_finish &&
                              <Button className="btn-danger"
                                variant="secondary"
                                //secondary={true}
                                onClick={() => this.controlAudio("inactive")}>Finish Recording</Button>}
                                */}
                          </div>
                        :
                          <ActivityIndicator theme="button-Status-Loader" />
                        }
                        {(!this.state.showRecordControls && this.state.clickArea === "paused" && this.state.local_file_url === null) ?
                          <span><em>Audio Processing - Please be patient</em></span>
                        : null
                        }
                        {(!this.state.showRecordControls && this.state.clickArea === "inactive" && this.state.final_local_file_url === null) ?
                          <span><em>Audio Processing - Please be patient</em></span>
                        : null
                        }
                      </div>
                    {/* <span><em>Slide Audio Saving</em></span> <ActivityIndicator theme="button-Status-Loader" /> */}
                    {/*</AudioAnalyser>*/}
                  </div>
                  <div className="center upload-audiofile">
                    <AudioRecorder
                      {...audioProps}
                      //audioRef={this.recorded_audio_ref}
                      //audioSeekCallback={() => this.seekRecording}
                      //audioPauseCallback={() => this.pauseRecording}
                      //audioStartCallback={() => this.startRecording}
                      //slide_indicator={this.state.slide_indicator}

                      //duration={this.state.duration}
                      //recording_status={audioRecordstatus}
                      //audioSrc={audioSrc}
                    />
                  </div>
                  { (this.state.local_file_url) &&
                  <div className="center">
                    <span className="center">Slide {this.state.current_slide} Audio<br/></span>
                    <audio
                        style = {{ width: "100%" }}
                        ref={this.recorded_audio_ref}
                        controls="controls" 
                        // src={this.props.receivedProps ? imageUrl : this.state.file}
                        src={this.state.local_file_url}
                        type={this.state.audioMimeType}
                        // src={imageUrl} 
                        //className="audio-file"
                        //onSeeked={this.seekRecording}
                        //onPause={this.pauseRecording}
                        //onPlay={this.startRecording}
                    />
                  </div>
                  }
                  { (this.state.clickArea === "inactive" && this.state.final_local_file_url) &&
                  <div className="center">
                    <span className="center">Final Presentation Audio<br/></span>
                    <audio
                      style = {{ width: "100%" }}
                      ref={this.recorded_audio_ref}
                      controls="controls" 
                      src={this.state.final_local_file_url} 
                      type={this.state.audioMimeType}
                      onSeeked={this.seekRecording}
                      onPause={this.pauseRecording}
                      onPlay={this.startRecording}
                    />
                  </div>
                  }
                </div>
              </Col>
            </Row>
            : 
            // Upload audio section
            (this.props.audioType === "upload") ?
              <div>
                <div className=" upload-audio flex-center">
                  <Button disabled={this.state.saving} className="btn btn-danger btn-global">
                    {upload_button_text}
                    <form className="uploader" encType="multipart/form-data">
                      <input
                        type="file"
                        accept="audio/*"
                        //name="local_file_url"
                        onChange={e => this.onChangeAudioFile(e)}
                        // onChange={e => this.onEditAudio(e)}
                        // onChange={this.props.receivedProps ? e => this.onEditAudio(e) : e => this.onChange(e)}
                      />
                    </form>
                  </Button>
                </div>
                <br/>
                <div style={{ display: this.state.local_file_url || this.props.receivedProps  ? "block" : "none" }}
                  className="center upload-audiofile">
                  {this.state.audioFileName ?
                    <div>
                    <span>{this.state.slide_indicator}<br/></span>
                    <span>Current audio filename: {this.state.audioFileName}<br/></span>
                    </div>
                    :
                    null
                  }

                  <audio
                    style = {{ width: "100%" }}
                    ref={this.recorded_audio_ref}
                    controls="controls" 
                    // src={this.props.receivedProps ? imageUrl : this.state.file}
                    src={this.state.local_file_url} 
                    // src={imageUrl} 
                    //className="audio-file"
                    onSeeked={this.seekRecording}
                    onPause={this.pauseRecording}
                    onPlay={this.startRecording}
                  />

                </div>
              </div>
              : null
        }
        { (isIOS && !usingMediaRecorder) &&
        <Row style={{ marginTop: "20px" }}>
          <Col xs={12} className="flex justify-content-center">
            <span style={{ fontSize: "smaller"}}>iOS audio recording will work best in Safari, and by enabling your browser's MediaRecorder: 1. Go to Settings → Safari → Advanced → Experimental Features; 2. Enable MediaRecorder</span>
          </Col>
        </Row>
        }         
         {/* Previous & Publish buttons */}
        <div className="form-group btn-position">


              <button
                className="btn btn-draft"
                onClick={this.onClickPre}
                disabled={this.state.saving}
              >
                Previous
              </button>
              <button
                className="btn btn-draft"
                onClick={() => this.handleCancel()}
                disabled={this.state.saving}
              >
                Cancel
              </button>
              {/*
              <button style={{ marginRight: "7px" }} className="btn btn-publish" onClick={this.AudioPushMet}>
                Save Progress
              </button>
              */}
              <button
                className="btn btn-publish"
                onClick={this.TriggerCreateVideo}
                disabled={this.state.saving}
              >
                Finish (Save + Create Video)
              </button>
              </div>

      </div>
    );
  }
}

export default withRouter(Presentation);
//export default Presentation;
